import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Button, Grid } from 'semantic-ui-react';
import { toast } from 'react-toastify';
import moment from 'moment';
import PropTypes from 'prop-types';

import { Filter, Main } from 'Containers';
import { getTableStates } from 'Common/UserSettings/helpers/helper';
import { setTableStates } from 'Common/UserSettings/state/actions';
import { clearTableSavedState } from 'Common/FormHelper';
import { TableNamesEnum } from 'Common/Constants/Enumeration/TableEnum';
import { TabEnum } from 'Common/Constants/Enumeration/KitchenPrepWorksheet';
import { DATE_FORMAT_FOR_UI, DATE_FORMAT_FOR_SERVER } from 'Common/Constants';
import { GenericEnum } from 'Common/Constants/Enumeration/CommonEnum';
import { AvailableKitchenPrepWorksheetEnum } from 'Common/FieldEnum';

import * as Selectors from './state/settings/selectors';
import { setSelectedTab } from './state/settings/actions';
import { BASE_URL } from './helper/createEditPrepWorksheet';
import { PreparedKitchenItemsComponent } from './containers/kitchenPrepWorksheetListing/KitchenPrepWorksheet';
import { AvailableKitchenPrepWorksheet } from './containers/availablePrepWorksheet/AvailableKitchenPrepWorksheet';

class KitchenPrepWorksheetContainer extends Component {
  static propTypes = {
    selectedTab: PropTypes.string.isRequired,
    allTableStates: PropTypes.object,
    setSelectedTab: PropTypes.func.isRequired,
    setTableStates: PropTypes.func.isRequired,
  };

  static defaultProps = {
    allTableStates: null,
  };

  headerRowButtons = [
    { title: 'Available', value: TabEnum.Available },
    {
      title: 'Kitchen Prep Worksheet',
      value: TabEnum.KitchenPrepWorksheet,
    },
  ];

  componentWillUnmount() {
    this.clearTableSavedState();
    toast.dismiss();
  }
  clearTableSavedState = () => {
    const { history, allTableStates, setTableStates } = this.props;
    clearTableSavedState(history, BASE_URL, allTableStates, setTableStates, [
      TableNamesEnum.CK_KITCHEN_PREP_WORKSHEET_TABLE,
    ]);
  };

  onCreateClick = () => {
    const deliveryDate = moment().format(DATE_FORMAT_FOR_SERVER);
    this.props.history.push(`${BASE_URL}/0/0/${deliveryDate}/0`);
  };

  render() {
    const { selectedTab } = this.props;
    return (
      <Fragment>
        <Filter title={''} newRow={true}>
          <Grid>
            <Grid.Row column={2}>
              <Grid.Column width={12}>
                <Button.Group basic className="btn-group--active-group">
                  {this.headerRowButtons.map(button => (
                    <Button
                      key={button.title}
                      basic
                      className="white"
                      active={selectedTab === button.value}
                      onClick={() => this.props.setSelectedTab(button.value)}
                    >
                      {button.title}
                    </Button>
                  ))}
                </Button.Group>
              </Grid.Column>
              <Grid.Column width={4} floated={'right'} textAlign={'right'}>
                {selectedTab === TabEnum.KitchenPrepWorksheet ? (
                  <Button
                    content="Create New"
                    type={'button'}
                    onClick={this.onCreateClick}
                  />
                ) : null}
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Filter>
        <Main shouldNotUsePageWidth>
          {selectedTab === TabEnum.Available ? (
            <AvailableKitchenPrepWorksheet
              initialValues={{
                [AvailableKitchenPrepWorksheetEnum.BeginDT]: moment().format(
                  DATE_FORMAT_FOR_UI
                ),
                [AvailableKitchenPrepWorksheetEnum.EndDT]: moment()
                  .add(1, 'month')
                  .format(DATE_FORMAT_FOR_UI),
                [AvailableKitchenPrepWorksheetEnum.Kitchen]:
                  GenericEnum.EmptyString,
              }}
            />
          ) : (
            <PreparedKitchenItemsComponent />
          )}
        </Main>
      </Fragment>
    );
  }
}
const mapStateToProps = state => {
  return {
    selectedTab: Selectors.getSelectedTab(state),
    allTableStates: getTableStates(state),
  };
};
const mapDispatchToProps = {
  setSelectedTab,
  setTableStates,
};

export const PreparedKitchenItems = connect(
  mapStateToProps,
  mapDispatchToProps
)(KitchenPrepWorksheetContainer);



// WEBPACK FOOTER //
// ./src/pages/centralkitchen/kitchenprepworksheet/KitchenPrepWorksheetContainer.js